import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  menteeModules: null,
  selectedMenteeModule: null,
  viewMiscellaneousMenteeModulesState: false,
  deleteMenteeModuleModalState: false,
  updateMenteeModuleStatusModalState: false,
  updateMenteeModuleOrderModalState: false,
  addMenteeModuleModalState: false,
  addMenteeModule: null,
  menteeModuleError: null,
  menteeModuleType: null,
};

export const updateMenteeModule = createSlice({
  name: 'updateMenteeModule',
  initialState,
  reducers: {
    setMenteeModules: (state, action) => {
      state.menteeModules = action.payload;
    },
    setDeleteMenteeModuleModalState: (state, action) => {
      state.deleteMenteeModuleModalState = action.payload;
    },
    setSelectedMenteeModule: (state, action) => {
      state.selectedMenteeModule = action.payload;
    },
    setUpdateMenteeModuleModalState: (state, action) => {
      state.updateMenteeModuleStatusModalState = action.payload;
    },
    setUpdateMenteeModuleOrderModalState: (state, action) => {
      state.updateMenteeModuleOrderModalState = action.payload;
    },
    setViewMiscellaneousMenteeModulesState: (state, action) => {
      state.viewMiscellaneousMenteeModulesState = action.payload;
    },
    setAddMenteeModuleModalState: (state, action) => {
      state.addMenteeModuleModalState = action.payload;
    },
    setAddMenteeModule: (state, action) => {
      state.addMenteeModule = action.payload;
    },
    setMenteeModuleError: (state, action) => {
      state.menteeModuleErrors = action.payload;
    },
    setMenteeModuleType: (state, action) => {
      state.menteeModuleType = action.payload;
    },
  },
});

export const {
  setMenteeModules,
  setDeleteMenteeModuleModalState,
  setSelectedMenteeModule,
  setMenteeModuleError,
  setUpdateMenteeModuleModalState,
  setUpdateMenteeModuleOrderModalState,
  setViewMiscellaneousMenteeModulesState,
  setAddMenteeModuleModalState,
  setAddMenteeModule,
  setMenteeModuleType,
} = updateMenteeModule.actions;
export default updateMenteeModule.reducer;
